import React, { useState } from 'react';
import { CheckCircleIcon, ClockIcon, TruckIcon, MapPinIcon, SearchIcon } from 'lucide-react';
import { Button } from '../components/Button';
import { useOrder } from '../context/OrderContext';
export const TrackingPage = () => {
  const {
    orderDetails
  } = useOrder();
  const [trackingNumber, setTrackingNumber] = useState(orderDetails.confirmationNumber || '');
  const [isTracking, setIsTracking] = useState(!!orderDetails.confirmationNumber);
  // Demo tracking status - in a real app, this would come from a server
  const trackingStatus = orderDetails.status || 'confirmed';
  const handleTrack = (e: React.FormEvent) => {
    e.preventDefault();
    if (trackingNumber) {
      setIsTracking(true);
    }
  };
  return <div className="bg-gray-50 min-h-screen py-10" data-id="element-398">
      <div className="container mx-auto px-4" data-id="element-399">
        <h1 className="text-3xl font-bold text-center mb-8" data-id="element-400">Track Your Move</h1>
        <div className="max-w-3xl mx-auto" data-id="element-401">
          {!isTracking ? <div className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-402">
              <form onSubmit={handleTrack} data-id="element-403">
                <h2 className="text-2xl font-bold mb-6" data-id="element-404">
                  Enter Your Tracking Number
                </h2>
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-405">
                  <input type="text" className="flex-grow px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g., MOV-123456" value={trackingNumber} onChange={e => setTrackingNumber(e.target.value)} required data-id="element-406" />
                  <Button type="submit" data-id="element-407">
                    <SearchIcon className="mr-2 h-5 w-5" data-id="element-408" /> Track
                  </Button>
                </div>
              </form>
            </div> : <div className="bg-white rounded-lg shadow-md p-6 md:p-8" data-id="element-409">
              <div className="mb-6" data-id="element-410">
                <h2 className="text-2xl font-bold mb-2" data-id="element-411">
                  Order #{trackingNumber}
                </h2>
                <div className="flex items-center text-gray-600" data-id="element-412">
                  <CalendarIcon className="mr-2 h-5 w-5" data-id="element-413" />
                  <span data-id="element-414">
                    {orderDetails.moveDate},{' '}
                    {orderDetails.moveTime === 'morning' ? 'Morning' : orderDetails.moveTime === 'afternoon' ? 'Afternoon' : 'Evening'}
                  </span>
                </div>
              </div>
              <div className="mb-8" data-id="element-415">
                <div className="flex mb-6" data-id="element-416">
                  <div className="w-10 flex-shrink-0 relative" data-id="element-417">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${trackingStatus !== 'draft' ? 'bg-green-500 text-white' : 'bg-gray-200'}`} data-id="element-418">
                      {trackingStatus !== 'draft' ? <CheckCircleIcon className="h-6 w-6" data-id="element-419" /> : 1}
                    </div>
                    {trackingStatus !== 'draft' && <div className="absolute top-10 bottom-0 left-1/2 w-1 -ml-0.5 bg-green-500" data-id="element-420"></div>}
                  </div>
                  <div className="ml-4" data-id="element-421">
                    <h3 className="font-bold text-lg" data-id="element-422">Booking Confirmed</h3>
                    <p className="text-gray-600" data-id="element-423">
                      Your moving request has been confirmed.
                    </p>
                    {trackingStatus !== 'draft' && <p className="text-sm text-green-600 mt-1" data-id="element-424">Completed</p>}
                  </div>
                </div>
                <div className="flex mb-6" data-id="element-425">
                  <div className="w-10 flex-shrink-0 relative" data-id="element-426">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${trackingStatus === 'in-progress' || trackingStatus === 'completed' ? 'bg-green-500 text-white' : trackingStatus === 'confirmed' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`} data-id="element-427">
                      {trackingStatus === 'in-progress' || trackingStatus === 'completed' ? <CheckCircleIcon className="h-6 w-6" data-id="element-428" /> : trackingStatus === 'confirmed' ? <ClockIcon className="h-6 w-6" data-id="element-429" /> : 2}
                    </div>
                    {(trackingStatus === 'in-progress' || trackingStatus === 'completed') && <div className="absolute top-10 bottom-0 left-1/2 w-1 -ml-0.5 bg-green-500" data-id="element-430"></div>}
                  </div>
                  <div className="ml-4" data-id="element-431">
                    <h3 className="font-bold text-lg" data-id="element-432">
                      Preparing for Your Move
                    </h3>
                    <p className="text-gray-600" data-id="element-433">
                      Our team is preparing equipment and personnel for your
                      move.
                    </p>
                    {trackingStatus === 'confirmed' && <p className="text-sm text-blue-600 mt-1" data-id="element-434">In Progress</p>}
                    {(trackingStatus === 'in-progress' || trackingStatus === 'completed') && <p className="text-sm text-green-600 mt-1" data-id="element-435">Completed</p>}
                  </div>
                </div>
                <div className="flex mb-6" data-id="element-436">
                  <div className="w-10 flex-shrink-0 relative" data-id="element-437">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${trackingStatus === 'completed' ? 'bg-green-500 text-white' : trackingStatus === 'in-progress' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`} data-id="element-438">
                      {trackingStatus === 'completed' ? <CheckCircleIcon className="h-6 w-6" data-id="element-439" /> : trackingStatus === 'in-progress' ? <TruckIcon className="h-6 w-6" data-id="element-440" /> : 3}
                    </div>
                    {trackingStatus === 'completed' && <div className="absolute top-10 bottom-0 left-1/2 w-1 -ml-0.5 bg-green-500" data-id="element-441"></div>}
                  </div>
                  <div className="ml-4" data-id="element-442">
                    <h3 className="font-bold text-lg" data-id="element-443">Moving in Progress</h3>
                    <p className="text-gray-600" data-id="element-444">
                      Your items are being transported from pickup to
                      destination.
                    </p>
                    {trackingStatus === 'in-progress' && <p className="text-sm text-blue-600 mt-1" data-id="element-445">In Progress</p>}
                    {trackingStatus === 'completed' && <p className="text-sm text-green-600 mt-1" data-id="element-446">Completed</p>}
                  </div>
                </div>
                <div className="flex" data-id="element-447">
                  <div className="w-10 flex-shrink-0" data-id="element-448">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${trackingStatus === 'completed' ? 'bg-green-500 text-white' : 'bg-gray-200'}`} data-id="element-449">
                      {trackingStatus === 'completed' ? <CheckCircleIcon className="h-6 w-6" data-id="element-450" /> : 4}
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-451">
                    <h3 className="font-bold text-lg" data-id="element-452">Move Completed</h3>
                    <p className="text-gray-600" data-id="element-453">
                      All items have been successfully delivered to the
                      destination.
                    </p>
                    {trackingStatus === 'completed' && <p className="text-sm text-green-600 mt-1" data-id="element-454">Completed</p>}
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-md mb-6" data-id="element-455">
                <h3 className="font-bold text-lg mb-3" data-id="element-456">Location Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-457">
                  <div data-id="element-458">
                    <div className="flex items-start" data-id="element-459">
                      <MapPinIcon className="mr-2 mt-1 text-blue-600 flex-shrink-0" size={18} data-id="element-460" />
                      <div data-id="element-461">
                        <p className="font-medium" data-id="element-462">From</p>
                        <p className="text-gray-600" data-id="element-463">
                          {orderDetails.pickupAddress}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-464">
                    <div className="flex items-start" data-id="element-465">
                      <MapPinIcon className="mr-2 mt-1 text-green-600 flex-shrink-0" size={18} data-id="element-466" />
                      <div data-id="element-467">
                        <p className="font-medium" data-id="element-468">To</p>
                        <p className="text-gray-600" data-id="element-469">
                          {orderDetails.dropoffAddress}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center" data-id="element-470">
                <p className="text-gray-600 mb-4" data-id="element-471">Need help with your move?</p>
                <Button variant="outline" data-id="element-472">Contact Support</Button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
};
// Helper component for the calendar icon
const CalendarIcon = ({
  className = '',
  size = 18
}) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-473">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-474"></rect>
    <line x1="16" y1="2" x2="16" y2="6" data-id="element-475"></line>
    <line x1="8" y1="2" x2="8" y2="6" data-id="element-476"></line>
    <line x1="3" y1="10" x2="21" y2="10" data-id="element-477"></line>
  </svg>;